/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { cn } from "tailwind-variants";
import { useVueProps, vueDefaultValue } from "common/vue/useVueProps";
/* eslint-disable max-lines-per-function */
/**
 * @deprecated Import SVG icons directly instead:
 *   import MyIcon from "assets/icons/my-icon.svg?vue";
 *   <MyIcon class="..." />
 */
import { getIconComponent } from "./useSvgIcons.react";

// @ts-ignore TS(6133): 'rawProps' is declared but its value is never read... Remove this comment to see the full error message
function getDefaultProps(rawProps: any) {
  return {
    type: vueDefaultValue("jiffy")
  };
}

export default function UseSvg(rawProps: any) {
  const { className, icon, type, ...restProps } = rawProps;

  const props = useVueProps(rawProps, getDefaultProps);

  function iconComponent() {
    return getIconComponent(props.current.icon, props.current.type);
  }

  return (
    <>
      {iconComponent()
        ? (() => {
            const DynamicTag = iconComponent();
            return (
              <DynamicTag className={cn(className)} {...restProps} data-testid="dynamic-tag" />
            );
          })()
        : null}
    </>
  );
}
